// TOP LEVEL IMPORTS
import React from 'react';
// ANT
import Card from 'antd/lib/card';
// COMPONENTS
import Result from 'components/common/Result';

const PaymentSuccessful = () => (
  <Card style={{ marginBottom: 20 }}>
    <Result
      type="success"
      title="We have received your payment!"
      description="Thank you for your business. Let us know if you have any questions."
    />
  </Card>
);

export default PaymentSuccessful;



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/PaymentFormArea/PaymentSuccessful/index.js